import { render, staticRenderFns } from "./FooterComponent.vue?vue&type=template&id=62da1487&"
import script from "./FooterComponent.vue?vue&type=script&lang=js&"
export * from "./FooterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports